<template>
  <body class="checkout">
    <div id="checkout" class="checkout-wrapper">
      <header class="checkout-header">
        <div style="padding: 20px">
          <div class="d-flex d-md-block justify-content-center">
            <a :href="BASE_URL"> <img
              :src="getLogo"
              width="220rem"
              text-center
              alt=""
              style="margin-right: 10px"
            /></a>
          </div>
          <div class="checkout-title">
            <div class="header-step step-one" :class="{ active: steps == 1 }">
              <h2>{{ $t("checkout.started") }}</h2>
            </div>
            <div class="header-step step-two" :class="{ active: steps == 2 }">
              <h2>{{ $t("checkout.extra") }}</h2>
            </div>
            <div class="header-step step-three" :class="{ active: steps == 3 }">
              <h2>{{ $t("checkout.almost_there") }}</h2>
            </div>
          </div>
          <div class="seperator seperator--bottom seperator--light"></div>
        </div>
      </header>

      <section class="checkout-content">
        <div class="container px-4">
          <div class="row">
            <div class="col-sm-7">
              <!-- LOGIN FORM -->
              <template v-if="loginForm">

                <div class="social-auth-links text-center mt-4 mb-3 hr">
                
                  <template v-if="!getAyoba()">
                  <button
                  :disabled="!onLine"
                    @click.prevent="loginWithGoogle('in')"
                     class="btn btn-block btn-outline-danger"
                  >
                    <i class="fab fa-google mr-2"></i>
                    {{ $t("checkout.signin_google") }} 
                  </button>
                  </template>

                  <button  
                          :disabled="!onLine"
                            @click.prevent="signupWithChenosis()"
                            class="btn btn-block btn-success mt-3"
                          >
                          {{ $t("checkout.signin_chenosis") }}
                            <img class="mr-3" src="@/assets/chenosis.svg" width="60" alt=""> 
                          </button>
             
                </div>

                  <hr>
                 <h3 class="text-center">{{ $t("checkout.or") }}</h3>
                <hr />

                <ValidationObserver ref="observer" v-slot="{ invalid, passes }">
                  <form @submit.prevent="passes(login)">
                    <validation-provider
                      name="email"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <div class="form-group mt-5">
                        <div class="row">
                          <div class="col-sm-12">
                            <input
                              v-model="form.email"
                              type="email"
                              class="form-control py-4"
                              :placeholder=" $t('checkout.email')"
                            />
                          </div>
                        </div>
                      </div>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </validation-provider>

                    <validation-provider
                      name="password"
                      rules="required|min:8"
                      v-slot="{ errors }"
                    >
                      <div class="form-group">
                        <div class="row">
                          <div class="col-sm-12">
                            <input
                              v-model="form.password"
                              type="password"
                              class="form-control py-4"
                              :placeholder="$t('checkout.password')"
                            />
                          </div>
                        </div>
                      </div>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </validation-provider>
                    <button
                      :disabled="invalid"
                      type="submit"
                      class="btn btn-block btn-info"
                    >
                    {{ $t("checkout.login") }}
                    </button>

                    <hr />
                    <p class="text-danger" v-if="server_errors.unauthorized">
                      {{ server_errors.unauthorized[0] }}
                    </p>
                  </form>
                </ValidationObserver>
            
              </template>
              <!-- END LOGIN FORM -->

              <template v-else>
                <!-- WELCOME  USER -->
                <template v-if="isLoggedIn && steps === 1">
                  <h2>{{ $t("checkout.welcome") }} {{ authUser.first_name }}</h2>

                  <span class="logged-in-as"
                    >{{ $t("checkout.login_as") }} {{ userInfo }}</span
                  >
                  <br />
                  <a
                    @click.prevent="$store.commit('CLEAR_AUTH_INFO')"
                    class="logged-signout"
                    href
                    >{{ $t("checkout.not") }} {{ authUser.first_name }} ? {{ $t("checkout.sign_out") }}.</a
                  >
                </template>
                <!-- END WELCOME -->
                <div class="form-wrapper">
                  <ValidationObserver
                    ref="observer"
                    v-slot="{ invalid, passes }"
                  >
                    <form @submit.prevent="passes(checkout)">
                      <section class="item first-step" v-show="steps == 1">
                        <!-- SIGN UP -->
                        <template v-if="!isLoggedIn">
                          <div class="social-auth-links text-center mt-2 mb-5">
                            <!-- <button  
                            :disabled="!onLine"
                              @click.prevent="FBlogin"
                              class="btn btn-block btn-primary mb-2"
                            >
                              <i class="fab fa-facebook"></i> Sign Up using
                              Facebook
                            </button> -->
                            <template v-if="!getAyoba()">
                            <button  
                            :disabled="!onLine"
                              @click.prevent="loginWithGoogle('up')"
                              class="btn btn-block btn-outline-danger mt-5"
                            >
                              <i class="fab fa-google mr-2"></i> {{ $t("checkout.sign_up_google") }} 
                            </button>
                            </template>

                            <button  
                            :disabled="!onLine"
                              @click.prevent="signupWithChenosis()"
                              class="btn btn-block btn-success mt-3"
                            >
                            {{ $t("checkout.sign_up_chenosis") }}
                              <img class="mr-3" src="@/assets/chenosis.svg" width="60" alt=""> 
                            </button>

                            <!-- <button  
                            :disabled="!onLine"
                              @click.prevent="loginWithTwitter"
                              class="btn btn-block"
                              style="background:teal;color:white"
                            >
                              <i class="fab fa-twitter mr-2"></i> Sign Up
                              using Twitter
                            </button>

                            <button  
                            :disabled="!onLine"
                              @click.prevent="loginWithLinkedIn"
                               class="btn btn-block btn-outline-primary" 
                            >
                              <i class="fab fa-linkedin-in mr-2"></i> Sign Up
                              using LinkedIn
                            </button> -->
                          </div>
                          <hr />
                          <h3 class="text-center">{{ $t("checkout.or") }}</h3>
                          <hr />

                          <h2>{{ $t("checkout.sign_up") }}</h2>

                          <validation-provider
                            name="last_name"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-12">
                                  <input
                                    v-model.trim="form.first_name"
                                    type="text"
                                    name="first_name"
                                    class="form-control py-4"
                                    :placeholder="$t('checkout.first_name')"
                                  />
                                </div>
                              </div>
                            </div>
                            <span class="text-danger">{{ errors[0] }}</span>
                          </validation-provider>

                          <validation-provider
                            name="last_name"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-12">
                                  <input
                                    v-model.trim="form.last_name"
                                    type="text"
                                    class="form-control"
                                    name="last_name"
                                    :placeholder="$t('checkout.last_name')"
                                  />
                                </div>
                              </div>
                            </div>
                            <span class="text-danger">{{ errors[0] }}</span>
                          </validation-provider>

                          <validation-provider
                            name="email"
                            rules="required|email"
                            v-slot="{ errors }"
                          >
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-12">
                                  <input
                                    v-model.trim="form.email"
                                    type="email"
                                    @keyup="checkEmail()"
                                    class="form-control"
                                    :placeholder="$t('checkout.email')"
                                  />

                                  <small class="mb-2">{{$t("checkout.tip_email_verification") }} </small>


                                  <p v-show="available" style="color: red">
                                    {{$t("checkout.email_registered") }}
                                    <br />

                                    <a
                                      @click.prevent="loginForm = true"
                                      style="
                                        font-weight: bold;
                                        color: darkblue;
                                        text-decoration: underline;
                                      "
                                      href
                                      >{{$t("checkout.login") }}</a
                                    >
                                    {{$t("checkout.pick_another") }}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <span class="text-danger">{{ errors[0] }}</span>
                          </validation-provider>

                          <validation-provider
                            name="password"
                            rules="required|min:8"
                            v-slot="{ errors }"
                          >
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-12">
                                  <input
                                    v-model.trim="form.password"
                                    type="password"
                                    name="password"
                                    class="form-control"
                                    :placeholder="$t('checkout.password')"
                                  />
                                </div>
                              </div>
                            </div>
                            <span class="text-danger">{{ errors[0] }}</span>
                          </validation-provider>

                          <validation-provider
                            name="password_confirmation"
                            rules="required|confirmed:password"
                            v-slot="{ errors }"
                          >
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-12">
                                  <input
                                    v-model.trim="form.password_confirmation"
                                    type="password"
                                    class="form-control"
                                    :placeholder="$t('checkout.password_confirmation')"
                                  />
                                </div>
                              </div>
                            </div>
                            <span class="text-danger">{{ errors[0] }}</span>
                          </validation-provider>

                          <validation-provider name="is_business">
                            <div class="form-group">
                              <label class="is-business" for="is-business">
                                <input
                                  v-model="form.is_business"
                                  class="checkbox"
                                  type="checkbox"
                                />
                                {{$t("checkout.business") }}
                              </label>
                            </div>
                          </validation-provider>
                          <validation-provider
                            name="company_name"
                            :rules="{
                              required_if: {
                                target: 'is_business',
                                values: true,
                              },
                            }"
                            v-slot="{ errors }"
                          >
                            <div
                              v-if="form.is_business == true"
                              class="form-group"
                            >
                              <div class="row">
                                <div class="col-sm-12">
                                  <input
                                    v-model.trim="form.company_name"
                                    type="text"
                                    class="form-control"
                                    :placeholder="$t('checkout.company')"
                                  />
                                </div>
                              </div>
                            </div>

                            <span class="text-danger">{{ errors[0] }}</span>
                          </validation-provider>
                        </template>
                        <!-- END SIGN UP -->
                        <h2 class="next-header"> {{$t("checkout.station_name") }}</h2>

                        <validation-provider
                          name="station_name"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-12">
                                <input
                                  v-model.trim="form.station_name"
                                  type="text"
                                  class="form-control py-4"
                                  :placeholder="$t('checkout.station')"
                                />
                              </div>
                            </div>
                          </div>

                          <span class="text-danger">{{ errors[0] }}</span>
                        </validation-provider>

                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-12">
                              <input
                                v-model="form.website"
                                type="text"
                                class="form-control py-4"
                                :placeholder="$t('checkout.website')"
                              />
                            </div>
                          </div>
                        </div>

                        <validation-provider
                          name="referral_code"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-12">
                                <input
                                  v-model.trim="form.referral_code"
                                  type="text"
                                  @keyup="checkReferralCode()"
                                  class="form-control py-4"
                                  placeholder="Referral code (required)"
                                  required
                                />
                                <p v-show="referralStatus.checked && !referralStatus.valid" style="color: red; margin-top: 10px;">
                                  {{ referralStatus.message }}
                                </p>
                                <p v-show="referralStatus.checked && referralStatus.valid" style="color: green; margin-top: 10px;">
                                  ✓ {{ referralStatus.message }}
                                  <span v-if="referralStatus.name"> - {{ referralStatus.name }}</span>
                                </p>
                              </div>
                            </div>
                          </div>
                          <span class="text-danger">{{ errors[0] }}</span>
                        </validation-provider>
                      </section>

                      <section class="item second-step" v-show="steps == 2">
                        <h4>{{$t("checkout.choose_extras") }}</h4>
                        <ul class="list-unstyled">
                          <li class="addon">
                            <h5 class="h2">{{ android.name }}</h5>
                            <div class="addon__details">
                              <div class="small">
                                <p>{{ android.description2 }}</p>
                              </div>
                              <div class="addon__price">
                                {{getCurrencySymbol}}
                                <span class="cost-addon">{{
                                 getAddonPrice( android.pricing)
                                }}</span>
                                <sub>
                                  /
                                  <span class="cost-period"> {{$t("checkout.one_time") }}</span>
                                </sub>
                              </div>
                              <div class="addon__action">
                                <span
                                  v-if="androidExist"
                                  class="btn btn-success included-in-plan"
                                  >Included</span
                                >
                                <span
                                  v-else
                                  @click="addThis(android)"
                                  class="add btn"
                                  :class="
                                    added(android)
                                      ? 'btn-success'
                                      : 'btn-primary'
                                  "
                                  >{{$t("checkout.add_this") }}</span
                                >
                              </div>
                            </div>
                            <small class="text-muted disclaimer"
                              >{{$t("checkout.disclaimer_google") }}</small
                            >
                          </li>
                          <li class="addon">
                            <h5 class="h2">{{ iphone.name }}</h5>
                            <div class="addon__details">
                              <div class="small">
                                <p>{{ iphone.description2 }}</p>
                              </div>
                              <div class="addon__price">
                                 {{getCurrencySymbol}}
                                <span class="cost-addon">{{
                                  getAddonPrice(iphone.pricing)
                                }}</span>
                                <sub>
                                  /
                                  <span class="cost-period">{{$t("checkout.one_time") }} </span>
                                </sub>
                              </div>
                              <div class="addon__action">
                                <span
                                  v-if="iphoneExist"
                                  class="btn btn-success included-in-plan"
                                  >{{$t("checkout.included") }}</span
                                >
                                <span
                                  v-else
                                  @click="addThis(iphone)"
                                  class="add btn"
                                  :class="
                                    added(iphone)
                                      ? 'btn-success'
                                      : 'btn-primary'
                                  "
                                  >{{$t("checkout.add_this") }}</span
                                >
                              </div>
                            </div>
                            <small class="text-muted disclaimer"
                              >{{$t("checkout.disclaimer_apple") }}</small
                            >
                          </li>

                          <li class="addon">
                            <h5 class="h2">{{ website.name }}</h5>
                            <div class="addon__details">
                              <div class="small">
                                <p>{{ website.description2 }}</p>
                              </div>
                              <div class="addon__price">
                                 {{getCurrencySymbol}}
                                <span class="cost-addon">{{
                                  getAddonPrice(website.pricing)
                                }}</span>
                                <sub>
                                  /
                                  <span class="cost-period">
                                    {{$t("checkout.one_time") }}
                                  </span>
                                </sub>
                              </div>
                              <div class="addon__action">
                                <span
                                  @click="addThis(website)"
                                  class="add btn"
                                  :class="
                                    added(website)
                                      ? 'btn-success'
                                      : 'btn-primary'
                                  "
                                  >{{$t("checkout.add_this") }}</span
                                >
                              </div>
                            </div>
                          </li>
                        </ul>
                      </section>
                      <!-- <register-step-three /> -->
                      <section class="item third-step" v-show="steps == 3">
                        <div
                          v-show="
                            billing_cycle.format == 'monthly' ||
                            pathnameCycle == 'monthly'
                          "
                          class="upgrade"
                        >
                          <div
                            v-show="billing_cycle.format == 'monthly'"
                            class="yearly"
                          >
                            <h3 class="text-center">{{$t("checkout.two_month_free") }}</h3>
                            <div class="yearly-content">
                              <p class="flush">
                                {{$t("checkout.annually_discount") }}
                                
                              </p>
                              <a
                                @click.prevent="setFormat('yearly')"
                                href="#"
                                class="btn btn-success"
                                >{{$t("checkout.pay_annually") }}</a
                              >
                            </div>
                          </div>

                          <div
                            v-show="
                              billing_cycle.format == 'yearly' &&
                              pathnameCycle == 'monthly'
                            "
                            class="monthly"
                            style="display: block"
                          >
                            <p class="flush">
                              {{$t("checkout.chose_annual_pay") }}
                              
                               {{getCurrencySymbol}}
                              <span class="cost-charge">{{ form.amount }}</span>
                             
                              {{$t("checkout.charge_after_trial") }}
                              <a
                                @click.prevent="setFormat('monthly')"
                                href="#"
                                title="Switch to monthly payments"
                                >{{$t("checkout.here") }}</a
                              >
                            </p>
                          </div>
                        </div>
                        <div class="note">
                          <h4>{{$t("checkout.few_mention") }}</h4>
                          <small class="">
                            {{$t("checkout.trial_ends") }}
                            <span class="date">
                              <strong>{{ trialDate }}</strong>
                            </span>
                            {{$t("checkout.then_charge") }}  {{getCurrencySymbol}}
                            <span class="cost-charge">{{ form.amount }}</span>
                            {{$t("checkout.per") }}
                            <span class="cost-period">{{
                              billing_cycle.label
                            }}</span
                            >{{$t("checkout.no_charging") }}
                          </small>
                        </div>

                        <div role="tabpanel">
                          <div v-if="steps == 3" class="form-group">
                            <small class="">
                              {{$t("checkout.policy") }}
                              
                            </small>
                            <br>
                            <label class="terms mt-4" for="terms">
                              <input
                                v-model="terms"
                                class="checkbox"
                                type="checkbox"
                              />
                              {{$t("checkout.confirm") }}
                              <!-- <a href="#!" target="_blank">Terms of Service</a>
                              and -->
                              <a href="https://ownaradio.com/privacy-policy" target="_blank">{{$t("checkout.agreement") }}</a
                              >.
                            </label>
                            <br>
                            <span class="text-danger" v-show="terms === false">
                              {{$t("checkout.required") }}
                            </span>
                          </div>
                        </div>
                      </section>

                      <div v-show="!loginForm" class="form-footer">
                        <a v-show="steps > 1" @click.prevent="back()" href="#"
                          >←  {{$t("checkout.back") }}</a
                        >
                        <div class="order-steps text-center">
                          {{$t("checkout.step") }}
                          <span>{{ steps }}/3</span>
                        </div>
                        <div class="form-footer__next text-right">
                          <button
                            v-show="steps != 3"
                            @click="passes(nextStep)"
                            :disabled="invalid"
                            class="btn btn-info"
                          >
                          {{$t("checkout.next") }}
                          </button>
                          <button
                              :disabled="invalid || processing"
                              v-show="steps === 3"
                              type="submit"
                              class="btn"
                              :class="processing ? 'btn-default' : 'btn-info'"
                            >
                              {{ processing ? $t("checkout.processing") : $t("checkout.start_trial") }}
                            </button>
                          <div id="recaptcha"></div>
                        </div>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </template>
            </div>
            <aside class="col-sm-5">
              <div class="checkout-sidebar">
                <div
                  class="plan-details radius"
                  :class="'plan--' + selectedPackage.slug"
                >
                  <header class="plan-header">
                    <h4> {{$t("checkout.select_plan") }}</h4>
                    <h2 class="plan-name">{{ selectedPackage.name }}</h2>
                    <p class="plan-description2">
                      {{ selectedPackage.description2 }}
                    </p>
                    <div class="plan-cost">
                      <strong>
                         {{getCurrencySymbol}}
                        <span>{{ form.amount }}</span>
                      </strong>
                      <small class="period">
                        {{$t("checkout.per") }}
                        <span class="cost-period">{{
                          billing_cycle.label
                        }}</span>
                      </small>
                    </div>
                  </header>

                  <ul class="list-unstyled plan-features">
                    <li>
                      <span>{{ getBenefit("storage") }}</span>{{$t("checkout.storage") }}
                    </li>
                    <li>
                      <span>{{ getBenefit("Listeners") }}</span>{{$t("checkout.listeners") }} 
                    </li>
                    <li>
                      <span class="bandwidth-limit">{{
                        getBenefit("Bandwith")
                      }}</span>
                      {{$t("checkout.bandwidth") }}
                    </li>
                    <li>
                      <span>{{ getBenefit("DJs") }}</span>{{$t("checkout.users") }}
                    </li>
                  </ul>
                  <div class="return text-center">
                    <a :href="BASE_URL + '/pricing'" class="text-muted"
                      >← {{$t("checkout.return") }}</a
                    >
                  </div>
                </div>
                <div
                  class="plan-addons plan-details radius"
                  :class="{
                    'plan-addons--hidden': !has_addon && addons.length == 0,
                  }"
                >
                  <header>
                    <h4>{{$t("checkout.your_extras") }}</h4>
                  </header>
                  <ul class="list-unstyled plan-features">
                    <li v-show="androidExist">{{ android.name }}</li>
                    <li v-show="iphoneExist">{{ iphone.name }}</li>
                    <template v-for="(addon, index) in addons">
                      <li
                        @click="removeThis(addon, index)"
                        :key="index"
                        class="removable"
                      >
                        <i class="fas fa-minus-circle pr-2"></i>
                        <span>{{ addon.name }}</span>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </aside>
            <chenosis-login-modal ref="chenosisLoginModal"></chenosis-login-modal>
          </div>
        </div>
      </section>
      <footer class="checkout-footer"></footer>
    </div>
  </body>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

import ApiService from "@/plugins/ApiService";
import { mapState } from "vuex";
import {
  DISPATCH_CHECKOUT,
  FETCH_AUTH_INFO,
  FETCH_ORDER,
  DISPATCH_LOGIN,
  REGISTER,
} from "@/store/action-types";
import { initFacebookSdk } from "@/plugins/utils";
import ChenosisLoginModal from "@/components/ChenosisLoginModal.vue"

import momentTZ from "moment-timezone";

export default {
  name: "Checkout",

  components: {
    ValidationObserver,
    ValidationProvider,
    ChenosisLoginModal
  },
  props: {
    plan: {
      required: true,
      type: String,
    },
    period: {
      required: true,
      type: String,
    },

     currency: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      terms: "",
      selectedPackage: {},
      android: {},
      iphone: {},
      website: {},
      has_addon: false,
      recapcha: "",
      available: false,
      loginForm: false,
      loading:false,
      steps: 1,
      addons: [],
      referralStatus: {
        checked: false,
        valid: false,
        message: "",
        name: "",
      },
      billing_cycle: {
        format: "",
        label: "",
        multiplier: 0,
      },
      form: {
        billing_cycle: "",
        amount: 0,
        email: "",
        password: "",
        password_confirmation: "",
        first_name: "",
        last_name: "",
        is_business: false,
        company_name: "",
        station_name: "",
        website: "",
        phone: "",
        station_timezone: momentTZ.tz.guess(),
        plan_id: this.plan,
        currency: this.currency,
        addons: [],
        referral_code: "",
      },
      pathnameCycle: this.period,
      error: null,
    };
  },

  async created() {
    // this.init();

    //console.log("this.currency")
    //console.log(this.currency)

    if (this.isLoggedIn) {
      this.$store.dispatch(FETCH_AUTH_INFO);
    }

    const data = await this.$store.dispatch(FETCH_ORDER, {
      plan: this.plan,
      period: this.period,
    });
    this.has_addon = data.hasAddon;
    this.selectedPackage = data.package;
    this.android = data.android;
    this.iphone = data.iphone;
    this.website = data.website;
    this.pathnameCycle = this.period;
    this.setFormat(this.period);
  },

  computed: {
    ...mapState({
      errors: (state) => state.errors,
      onLine: (state) => state.auth.onLine,
    }),

    userInfo() {
      return this.authUser.email || this.authUser.phone;
    },

    getCurrencySymbol(){
      if(this.currency === 'ghs'){
        return '¢';
      } else if(this.currency === 'usd'){
        return '$';
      }else if(this.currency === 'ngn'){
        return '₦';
      }
    },

    getLogo() {
      return require("@/assets/long-logo.svg");
    },
    androidExist() {
      if (this.selectedPackage.benefits != undefined) {
        return this.selectedPackage.benefits["Android App"] == true;
      }
    },
    iphoneExist() {
      if (this.selectedPackage.benefits != undefined) {
        return this.selectedPackage.benefits["Iphone App"] == true;
      }
    },

    totalCost() {
      return (this.form.amount =
        Number(this.selectedPackage.pricing[this.currency]) * this.billing_cycle.multiplier +
        this.addons
          .map((addon) => Number(addon.pricing[this.currency]) * this.billing_cycle.multiplier)
          .reduce((a, b) => a + b, 0));
    },

    trialDate() {
      let endDate = new Date(Date.now() + 7 * 24 * 3600 * 1000);
      return new Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(endDate);
    },
  },

  watch: {
    billing_cycle() {
      this.totalCost;
    },

    "form.is_business": function (newVal) {
      if (!newVal) {
        this.form.company_name = "";
      }
    },
  },

  methods: {

    getAddonPrice(pricing){
      if(this.currency != undefined && pricing != undefined){
        return pricing[this.currency]
      }
      return ''

    },

    getBenefit(benefit) {
      if (Object.keys(this.selectedPackage) != 0) {
        return this.selectedPackage.benefits[benefit];
      }
      return "";
    },

    async checkout() {
      
      try {
        if (this.terms == false) {
          this.terms = false;
          return;
        }

        // Validate referral code before proceeding
        if (!this.referralStatus.valid) {
          this.error = "Please provide a valid referral code";
          this.steps = 1;
          return;
        }

        //TODO: Accept order Currency
        this.form.amount = Number(this.selectedPackage.pricing[this.currency]) * this.billing_cycle.multiplier +
        this.addons.map((addon) => Number(addon.pricing[this.currency]) * this.billing_cycle.multiplier)
        .reduce((a, b) => a + b, 0);

        await this.$store.dispatch(DISPATCH_CHECKOUT, this.form);

        this.loginForm = false;
        this.$router.push("/verify-token", () => {});
      } catch (error) {
        this.$refs.observer.setErrors(this.server_errors);
        this.steps = 1;
      }
    },

    async login() {
       this.loading = true
      try {
        await this.$store.dispatch(DISPATCH_LOGIN, this.form);
        
        this.loginForm = false;
      } catch (error) {
        // this.error = error;
        this.$refs.observer.setErrors(this.server_errors);
         this.loading = false
      }
    },

    async checkEmail() {
      let res = await ApiService.get(
        "/checkout/email_availability/" + this.form.email
      );
      this.available = res.data;
    },

    async checkReferralCode() {
      if (!this.form.referral_code || this.form.referral_code.length < 3) {
        this.referralStatus.checked = false;
        return;
      }

      try {
        let res = await ApiService.get(
          "/checkout/referral_availability/" + this.form.referral_code
        );
        
        this.referralStatus.checked = true;
        this.referralStatus.valid = res.data.valid;
        this.referralStatus.message = res.data.message;
        this.referralStatus.name = res.data.name || "";
      } catch (error) {
        this.referralStatus.checked = true;
        this.referralStatus.valid = false;
        this.referralStatus.message = "Error checking referral code";
      }
    },

    validatePhone(e) {
      if (e.valid === true) {
        //console.log(e);
        this.form.phone = e.number;
        this.form.country = e.country.name.split(" ")[0];
        // this.form.errors.clear("phone");
      } else {
        this.form.phone = "";
        // this.form.errors.setError("phone", ["Invalid Phone Number"]);
      }
    },

    nextStep() {
      // Validate referral code before moving to next step
      if (this.steps === 1) {
        if (!this.form.referral_code || this.form.referral_code.length < 3) {
          this.error = "Please enter a referral code";
          return;
        }
        if (!this.referralStatus.valid) {
          this.error = "Please provide a valid referral code";
          return;
        }
      }
      
      this.error = null;
      this.steps++;
    },
    back() {
      if (this.steps > 1) {
        this.steps--;
      }
    },

    added(item) {
      return this.addons.some((addon) => addon.id === item.id);
    },

    setFormat(billing_cycle) {
      this.form.billing_cycle = billing_cycle;
      if (billing_cycle == "yearly") {
        this.billing_cycle = {
          format: "yearly",
          multiplier: 10,
          label: "yr",
        };
      } else if (billing_cycle == "monthly") {
        this.billing_cycle = {
          format: "monthly",
          multiplier: 1,
          label: "mo",
        };
      } else if (billing_cycle == "one-time") {
        this.billing_cycle = {
          format: "one-time",
          multiplier: 1,
          label: "one-time",
        };
      }
    },

    addThis(item) {
      if (!this.addons.some((addon) => addon.id === item.id)) {
        this.form.amount +=
          // Number(item.pricing[this.currency]) * this.billing_cycle.multiplier;
          Number(item.pricing[this.currency]);
        this.addons.push(item);
        this.form.addons.push(item.id);
      }
    },
    removeThis(item, index) {
      // this.form.amount -= item.pricing[this.currency] * this.billing_cycle.multiplier;
      this.form.amount -= item.pricing[this.currency];

      this.addons.splice(index, 1);
      this.form.addons.splice(index, 1);
    },
    async FBlogin() {

       this.loading = true

      FB.login(
        (response) => {
          if (response.authResponse) {
            FB.api(
              "/me/",
              { fields: "id, first_name, last_name, email" },
              (response) => {
                const form = {
                  email: response.email,
                  provider: "facebook",
                  provider_user_id: response.id,
                  name: response.first_name + " " + response.last_name,
                  first_name: response.first_name,
                  last_name: response.last_name,
                  phone: this.form.phone,
                  avatar: `https://graph.facebook.com/${response.id}/picture?type=normal`
                };


                this.$store
                  .dispatch(REGISTER, form)
                  .then(() => {
                    this.loginForm = false;
                    this.$router.push(
                      `/checkout/${this.plan}/${this.period}/${this.currency}`,
                      () => {}
                    );
                    // this.$router.go("/", ()=>{});
                  })
                  .catch(() => {
                     this.loading = false
                  });
              }
            );
          }
        },
        { scope: "email" }
      );
    },

    async loginWithGoogle(value) {
      try {
        const GoogleUser = await this.$gAuth.signIn();
        const form = {
          email: GoogleUser.getBasicProfile().getEmail(),
          provider: "google",
          provider_user_id: GoogleUser.getId(),
          name: GoogleUser.getBasicProfile().getName(),
          first_name: GoogleUser.getBasicProfile().getGivenName(),
          last_name: GoogleUser.getBasicProfile().getFamilyName(),
          avatar: GoogleUser.getBasicProfile().getImageUrl(),
          phone: this.form.phone,
        };
        const route = value === "in" ? DISPATCH_LOGIN : REGISTER;
        await this.$store.dispatch(route, form);
        this.loginForm = false;
        this.$router.push(`/checkout/${this.plan}/${this.period}/${this.currency}`, () => {});
      } catch (error) {
      }
    },

     signupWithChenosis(){

      try {

        this.$refs.chenosisLoginModal.create('register')

      } catch (error) {
        console.log(error);
       
      }

    },

     async loginWithTwitter() {
      try {
        const res = await ApiService.send("twitter/main/login", "get");

        window.location.href = res.data;
      } catch (error) {
        //console.log(error);
       
      }
    },

    async loginWithLinkedIn(){

         try {
        const res = await ApiService.send("linkedin/main/login", "get");
        window.location.href = res.data;
      } catch (error) {
        // console.log(error);
       
      }

    },

    async socialRedirect() {
      //not secure. try clearing browser history
      const params = new URL(document.location).searchParams;
      const userJSON = params.get("user");
      const access_token = params.get("access_token");
      if (userJSON && access_token) {
        const user = JSON.parse(userJSON);
        await this.$store.commit(SET_AUTH_INFO, { user, access_token });

        this.$router.replace("/", () => {});
      }
    },
  },

  mounted() {
    // initFacebookSdk();
    this.socialRedirect()

    // const phone = '+233243270000'
    // this.form.phone = phone.substring(1)

    const phone = this.getAyoba()?.getMsisdn();
    this.phone = phone ?  phone.substring(1) : null;


      if (this.authUser && this.authUser.stations?.length > 0) {
      swal.fire({
                text: `You have already created a radio. Please login to start streaming`,
                confirmButtonText: "ok",
                confirmButtonColor: "#e64942",
                showCancelButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false, 
                focusCancel: true,
              }).then((result) => {
                  window.location.href = process.env.VUE_APP_FRONTEND_BASE_URL + '/login'
                
              });
    }


    

  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

body {
  font-size: 18px;
  line-height: 1.4;
  color: #0f0f0f;
  background-color: #f7f7f6;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}

[role="button"] {
  cursor: pointer;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: GT Haptik, Helvetica Neue, Helvetica, sans-serif;
  font-weight: 500;
  line-height: 1.2;
  color: inherit;
}

.h1,
.h2,
.h3,
h1,
h2,
h3 {
  margin-top: 22px;
  margin-bottom: 11px;
}

.h1 .small,
.h1 small,
.h2 .small,
.h2 small,
.h3 .small,
.h3 small,
h1 .small,
h1 small,
h2 .small,
h2 small,
h3 .small,
h3 small {
  font-size: 65%;
}

.h4,
.h5,
.h6,
h4,
h5,
h6 {
  margin-top: 11px;
  margin-bottom: 11px;
}

.h4 .small,
.h4 small,
.h5 .small,
.h5 small,
.h6 .small,
.h6 small,
h4 .small,
h4 small,
h5 .small,
h5 small,
h6 .small,
h6 small {
  font-size: 75%;
}

.h1,
h1 {
  font-size: 50px;
}

.h2,
h2 {
  font-size: 30px;
}

.h3,
h3 {
  font-size: 20px;
}

.h4,
h4 {
  font-size: 16px;
}

.h5,
h5 {
  font-size: 14px;
}

.h6,
h6 {
  font-size: 12px;
}

p {
  margin: 0 0 11px;
}

.lead {
  margin-bottom: 22px;
  font-size: 18px;
  font-weight: 300;
  line-height: 1.4;
}

@media (min-width: 768px) {
  .lead {
    font-size: 24px;
  }
  .small {
    width: 25%;
  }
}

.small,
small {
  font-size: 87%;
}

.btn {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  padding: 9px 20px;
  font-size: 16px;
  line-height: 1.4;
  border-radius: 23px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.form-group--plan strong {
  font-size: 26px;
}

.form-group--plan span {
  margin: 0 20px;
}

.form-group--plan select.plan-select {
  width: auto;
}

ul.addon-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

ul.addon-list li {
  display: -ms-flexbox;
  display: flex;
  margin-right: 15px;
  font-size: 14px;
}

.amount {
  -ms-flex-pack: center;
  justify-content: center;
}

.amount strong {
  margin: 0 20px;
  font-size: 42px;
  color: #e94848;
}

.checkout {
  background-color: #eaf2f6;
}

.checkout-wrapper {
  padding-bottom: 90px;
}

.checkout-wrapper .carousel-inner {
  overflow: visible;
}

.checkout-wrapper .chosen-container {
  width: 100% !important;
  max-width: 100%;
  min-width: 170px;
}

.checkout-wrapper .form-control {
  padding: 9px 0;
}

.checkout-wrapper .form-control:focus {
  box-shadow: none;
}

.checkout-wrapper .chosen-search input[type="text"],
.checkout-wrapper .chosen-single,
.checkout-wrapper .form-control,
.checkout-wrapper select.form-control {
  width: 100%;
  border: none;
  border-radius: 0;
  background-color: transparent;
  box-shadow: none;
}

.checkout-wrapper .chosen-single,
.checkout-wrapper .form-control,
.checkout-wrapper select.form-control {
  border-bottom: 1px solid currentColor;
}

.checkout-wrapper .chosen-container-active .chosen-single {
  background-color: transparent;
}

.checkout-wrapper .chosen-container-single .chosen-single div {
  width: 20px;
}

.checkout-wrapper .chosen-search input[type="text"] {
  background-image: none !important;
}

.checkout-wrapper .chosen-single {
  padding: 0;
}

.checkout-wrapper .chosen-container-active .chosen-single {
  border: none;
  box-shadow: none;
  border-bottom: 1px solid currentColor;
}

.checkout-wrapper .chosen-container-single-nosearch .chosen-search {
  display: none;
}

.checkout-wrapper .chosen-drop {
  border: none;
  border-top: 1px solid currentColor;
  border-bottom: 1px solid #d7d8d1;
  border-radius: 0;
  background-color: #eaf2f6;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
}

.checkout-wrapper .chosen-drop .chosen-search {
  padding: 4px 6px;
  border: 1px solid #d7d8d1;
  border-top: none;
}

.checkout-wrapper .chosen-drop .chosen-search input[type="text"] {
  background-color: #fff;
  border-radius: 4px;
  outline: none;
}

.checkout-wrapper .chosen-drop li {
  border: 1px solid #d7d8d1;
  border-bottom: 0;
  padding: 8px;
}

.checkout-wrapper .chosen-drop li:first-of-type {
  border-top: none;
}

.checkout-wrapper .chosen-drop li.highlighted,
.checkout-wrapper .chosen-drop li.no-results {
  font-weight: 700;
  color: #0f0f0f;
  background-color: #eaf2f6;
}

.checkout-wrapper ul.chosen-results {
  max-height: 118px;
  padding: 0;
  margin: 0;
}

.form-wrapper {
  padding-top: 10px;
}

.form-wrapper label {
  font-weight: 400;
}

.checkout-footer,
.checkout-title {
  text-align: center;
  margin: 0 auto;
  max-width: 1040px;
}

.checkout-footer {
  padding: 0 10px;
}

.checkout-content {
  margin: 0 auto 60px;
  max-width: 1040px;
}

.checkout-sidebar {
  margin: 120px 0 0;
}

@media (min-width: 768px) {
  .checkout-sidebar {
    margin: -130px auto 0;
  }
}

.plan-details {
  margin-bottom: 40px;
  background-color: #fff;
  position: relative;
  z-index: 2;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
}

@media (min-width: 768px) {
  .plan-details {
    max-width: 363px;
  }
}

.plan-details header {
  padding: 18px;
  text-align: center;
}

.plan-details header.plan-header {
  padding: 40px;
}

.plan-details header h4 {
  font-weight: 700;
}

.plan-details header > :last-child,
.plan-details header > :last-child > :last-child {
  margin-bottom: 0;
}

.plan-addons--hidden {
  display: none;
}

h2.plan-name {
  font-family: Brown Light, Helvetica Neue, Helvetica, sans-serif;
  font-weight: 300;
}

.plan-cost {
  line-height: 1.2;
}

.plan-cost strong {
  font-size: 40px;
}

.plan-cost small {
  display: block;
}

#braintree-dropin > div.braintree-card {
  border: none;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
  margin-top: -30px;
}

#braintree-dropin > div.braintree-heading {
  font-weight: 600;
}

.plan-features {
  margin: 0;
}

.plan-features li {
  padding: 16px 14px;
  border-bottom: 1px solid #eaf2f6;
  font-weight: 700;
  text-align: center;
}

.plan-features li:first-of-type {
  border-top: 1px solid #eaf2f6;
}

.return {
  padding: 17px 14px 16px;
}

.checkout-header {
  position: relative;
  color: #fff;
  background-color: #7042c1;
}

.checkout-header .logo {
  position: absolute;
  top: 20px;
  left: 20px;
}

.checkout-title {
  padding: 10px 10px;
}

@media (min-width: 768px) {
  .checkout-title {
    padding: 0 10px 130px 0px;
  }
}

@media (min-width: 768px) {
  .header-step h1 {
    font-size: 70px;
  }
}

.header-step:not(.active) {
  display: none;
}

.note {
  margin-bottom: 50px;
}

.business-details {
  display: none;
}

.next-header {
  margin-top: 60px;
}

.form-footer {
  margin: 40px 0;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-align: center;
  align-items: center;
}

.form-footer * {
  -ms-flex: 1;
  flex: 1;
}

.form-footer a.back {
  color: #0f0f0f;
}

.plan-name {
  margin: 20px 0;
}

.plan-description {
  margin: 0 auto 30px;
  max-width: 248px;
}

.plan--bronze .plan-features,
.plan--bronze .plan-name {
  color: #855d4b;
}

.plan--silver .plan-features,
.plan--silver .plan-name {
  color: #7f7f7f;
}

.plan--gold .plan-features,
.plan--gold .plan-name {
  color: #b9a26f;
}

.plan--pro .plan-features,
.plan--pro .plan-name {
  color: #1e6890;
}

.addon {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid currentColor;
}

.addon__price {
  font-size: 20px;
  letter-spacing: -0.02em;
  font-weight: 700;
  padding: 0 0 0 30px;
  text-align: right;
}

.addon__price sub {
  bottom: 0;
}

@media (min-width: 768px) {
  .addon__price {
    margin: 0 30px;
    text-align: center;
  }
}

.addon__details {
  display: -ms-flexbox;
  display: flex;
}

@media (max-width: 768px) {
  .addon__details {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .addon__details div:not(.addon__action) {
    width: 50%;
  }
}

.addon__details p {
  margin-bottom: 15px;
}

@media (max-width: 768px) {
  .addon__action {
    width: 100%;
    margin: 0 0 10px;
  }
  .addon__action .btn {
    width: 100%;
  }
}

.upgrade {
  padding: 15px 30px;
  margin-bottom: 40px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 6px rgb(0 0 0 / 10%);
}
</style>